<template>
  <div
    :class="`mc-input-number formulate-input-element formulate-input-element--${context.type} input-${size}`"
    :data-type="context.type"
  >
    <FormulateInput type="text" v-model="context.model" v-bind="context.$attr" :disabled="disabled">
      <template #prefix>
        <div class="multiselect">
          <multiselect
            v-model="phoneCode"
            placeholder=""
            label="name"
            track-by="name"
            :options="allCountries"
            :option-height="4"
            :disabled="disabled"
          >
            <template slot="singleLabel" slot-scope="props"
              ><img class="option__image" :src="props.option.flag" :alt="props.option.name" />
              <span class="option__title">{{ props.option.number }}</span>
            </template>
            <template slot="option" slot-scope="props">
              <img class="option__image" :src="props.option.flag" :alt="props.option.name" />
              {{ ' ' }}
              <span class="option__title">{{ props.option.number }} {{ props.option.name }}</span>
            </template>
          </multiselect>
        </div>
      </template>
    </FormulateInput>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import allCountries from './lib/allCountries'

export default {
  components: {
    Multiselect,
  },

  props: {
    context: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      default: 'md',
    },
    countryCode: {
      type: String,
      default: '+62',
    },
    placeholder: {},
    disabled: {},
  },

  data() {
    return {
      allCountries,
      phoneCode: {
        name: 'Indonesia',
        flag: 'https://upload.wikimedia.org/wikipedia/commons/9/9f/Flag_of_Indonesia.svg',
        number: '+62',
      },
      isValid: true,
      isPossible: true,
    }
  },

  watch: {
    phoneCode: {
      handler(e) {
        if (e === null) {
          this.phoneCode = {
            name: 'Indonesia',
            flag: 'https://upload.wikimedia.org/wikipedia/commons/9/9f/Flag_of_Indonesia.svg',
            number: '+62',
          }
        }

        this.$emit('countryCode', e.number)
      },
    },
  },
}
</script>
